import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
import { listClients } from 'redux/modules/model/client'
import { createProfile } from 'redux/modules/model/profile'
import { clientsSelector } from 'redux/selectors'
import { ProfileForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class ProfileAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    createProfile: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, listClients } = this.props
    listClients({ clientId })
  }

  handleSubmit = (values) => {
    const { clientId, history, createProfile } = this.props
    return formSubmit(createProfile, { ...values })
      .then(() => history.push(ROUTES.PROFILE))
  };

  render() {
    const { clientList, sites } = this.props
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.PROFILE}>&laquo; Back</Link></p>
          <PageContentTitle>Add a new profile</PageContentTitle>
          <ProfileForm onSubmit={this.handleSubmit} clients={clientList} sites={sites} />
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientList: clientsSelector
})

export const actions = {
  createProfile,
  listClients
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(ProfileAdd)



// WEBPACK FOOTER //
// ./src/pages/profile/profile-add/index.js